export default function scrollFunction(el) {
  el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}



// WEBPACK FOOTER //
// ./src/utils/scroll.js